module.exports = __webpack_public_path__ + "img/color-metal-nobackground.707f59ce.png";